export default __webpack_public_path__ + "static/media/Boton-Connect-2.3d7b8518.png";